import { defineComponent as _defineComponent } from 'vue'
import { convertCharAndConvertToHtml as convertToHtml } from '@/heplers';
import type { ChildMethod } from '@/templates/NewRoutes';
import { Badge, getBadgeKeys } from '@/components/docs-main/reference-pages/badge';


export default /*#__PURE__*/_defineComponent({
  __name: 'Params',
  props: {
    parameters: null
  },
  setup(__props: any) {



return { __sfc: true,convertToHtml, Badge, getBadgeKeys }
}

})